import axios from 'axios';

export const HTTPSPA = axios.create({
  baseURL: `https://tagpres.com/TagPressSpayAPIs/APIs/`,
  timeout: 10000,
  maxRedirects: 5,
  transformResponse: [(data) => {
    try {
      const parsed = JSON.parse(data);
      return parsed;
    } catch (e) {
      console.warn('Failed to parse JSON response:', e.message);
      return data;
    }
  }]
});

// Add response interceptor for error handling
HTTPSPA.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.warn('Request timeout');
      return Promise.reject(new Error('Request timeout'));
    }
    if (error.message.includes('circular') || error.message.includes('recursion')) {
      console.warn('Circular reference detected');
      return Promise.reject(new Error('Invalid response structure'));
    }
    return Promise.reject(error);
  }
);
